module.exports = __webpack_public_path__ + "static/img/14000059.8f89153e.png";